import { Edge, Node } from 'reactflow';

import { Option } from '@/lib/v2/components';

import { NODE_WIDTH } from '@/src/modules/RulesModule/constants';
import { NodeData } from '@/src/modules/RulesModule/interfaces';
import { getId } from '@/src/modules/RulesModule/utils/getId';

interface InitialFlowProps {
  trigger?: Option;
}

export const useInitialFlow = () => {
  const generateInitialNodes = ({ trigger }: InitialFlowProps): Node<NodeData>[] => {
    const nodes: Node<NodeData>[] = [];
    const centerX = window.innerWidth / 2 - NODE_WIDTH / 2;

    if (trigger) {
      nodes.push({
        id: getId({ type: 'trigger', trigger }),
        type: 'trigger',
        position: { x: centerX, y: 20 },
        data: {},
      });
    }

    return nodes;
  };

  const generateInitialEdges = (): Edge[] => {
    const edges: Edge[] = [];
    return edges;
  };

  return {
    generateInitialNodes,
    generateInitialEdges,
  };
};
